import * as types from '../actions/productionQueueAction';

const initialState = {
  restaurantUuid: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  currentQueue: 'production',
  showTimersPreview: false,
  grilledQueue: {
    loading: false,
    data: [],
  },
};

const productionQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_PRODUCTION_QUEUE_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_PRODUCTION_QUEUE_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.START_QUEUE_CONNECTION:
      return {
        ...state,
        grilledQueue: {
          ...state.grilledQueue,
          loading: true,
        },
      };

    case types.SET_GRILLED_QUEUE_DATA:
      return {
        ...state,
        grilledQueue: {
          data: action.payload,
          loading: false,
        },
      };

    case types.RESET_QUEUE_DATA:
      return {
        ...state,
        grilledQueue: {
          ...state.grilledQueue,
          data: [],
        },
      };

    case types.RESET_PRODUCTION_QUEUE_STORE:
      return {
        ...initialState,
        showTimersPreview: state.showTimersPreview,
      };

    default:
      return state;
  }
};

export default productionQueueReducer;
